import { UiNode, UiNodeInputAttributes } from '@ory/client';
import { Alert, Stack, Text } from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';
import { Button } from 'src/components';
import { OidcFormButton } from 'src/components/convenience/auth/OidcFormButton';
import { AuthFeedback } from 'src/auth/components/AuthFeedback';

type InviteVariant = 'password' | 'sso_only';

interface WelcomeSectionProps {
  firstName: string;
  inviterName: string;
  userEmail: string;
  error: string | null;
  onAcceptInvite: () => void;
  variant: InviteVariant;
  oidcNodes: UiNode[];
  formAction: string;
  csrfToken: string;
}

export const WelcomeSection = ({
  firstName,
  inviterName,
  userEmail,
  error,
  onAcceptInvite,
  variant,
  oidcNodes,
  formAction,
  csrfToken,
}: WelcomeSectionProps) => (
  <Stack align="center" gap="md">
    <Text c="gray.0" fz={36} fw={700}>
      {firstName ? `Hi, ${firstName}!` : 'Welcome!'}
    </Text>
    <Text c="gray.0" ta="center" fz={24} fw={500}>
      You have been invited by {inviterName || '[NAME]'} to join Afternoon.
      <br />
      {variant === 'sso_only'
        ? 'Please sign in with your organization account to continue'
        : 'Please create your profile to continue'}
    </Text>
    {userEmail && (
      <Text c="gray.5" size="sm">
        {userEmail}
      </Text>
    )}

    <AuthFeedback error={error} />

    {variant === 'password' ? (
      <Button onClick={onAcceptInvite} disabled={!!error} size="lg">
        Accept invite & create profile
      </Button>
    ) : oidcNodes.length > 0 ? (
      <Stack gap="sm" w={300}>
        {oidcNodes.map(node => (
          <OidcFormButton
            key={(node.attributes as UiNodeInputAttributes).value as string}
            node={node}
            formAction={formAction}
            csrfToken={csrfToken}
            action="link"
          />
        ))}
      </Stack>
    ) : (
      <Alert icon={<IconAlertCircle size={16} />} color="yellow" variant="light" w={450}>
        No SSO providers configured. Please contact your administrator.
      </Alert>
    )}
  </Stack>
);
